import _ from "lodash";

export default function convertKeysToCamelCase(obj) {
  if (Array.isArray(obj)) {
    return obj.map(convertKeysToCamelCase);
  }
  if (obj && typeof obj === "object") {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [_.camelCase(key), convertKeysToCamelCase(value)])
    );
  }
  return obj;
}
